module.exports = __webpack_public_path__ + "static/biotrillion-c7cc0ec88dad7d867e18ea7824081e18.png";